/** 
 * Copyright © INOVUA TRADING.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.Provider = exports.Consumer = void 0;
var _react = _interopRequireDefault(require("react"));
var DataGridContext = _react.default.createContext(null);
var Provider = DataGridContext.Provider;
exports.Provider = Provider;
var Consumer = DataGridContext.Consumer;
exports.Consumer = Consumer;
var _default = DataGridContext;
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./~/@inovua/reactdatagrid-community/context.js
// module id = 144
// module chunks = 0